<template>
    <div>
        <!-- 정보입력 -->
        <div class="join-row-wrap">
            <!-- 정보입련: 일반 -->
            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">회원정보 필수입력</h3>
                </div>
                <div role="table" class="board-table board-table--input">
                    <div role="rowgroup">
                        <input-row label="아이디">
                            <input v-model="user.username" @input="input" name="username" class="w-100">
                        </input-row>
                        <input-row label="비밀번호">
                            <input  v-model="user.password" @input="input" name="password" type="password" class="w-100">
                            <p class="d-block text-grey mt-4 font-size-10 font-size-lg-12">* (영문대소문자/숫자/특수문자 조합, 8 - 16자)</p>
                        </input-row>
                        <input-row label="비밀번호 확인">
                            <input v-model="user.passwordConfirm" @input="input" name="password2" type="password" class="w-100">
                        </input-row>
                        <input-row label="기업명">
                            <input v-model="user.companyName" @input="input" name="companyName" class="w-100">
                        </input-row>
                        <input-row label="대표자명">
                            <input v-model="user.ceoName" @input="input" name="ceoName" class="w-100">
                        </input-row>
                        <input-row label="기업설립일">
                            <input v-model="user.establishedAt" @input="input" type="date" name="establishedAt" class="w-100">
                        </input-row>
                        <input-row label="사업자등록번호">
                            <input v-model="user.businessNumber" @input="input" name="businessNumber" maxlength="10" class="w-100">
                        </input-row>
                        <input-row label="연락처">
                            <v-row align="center" class="row--x-small">
                                <v-col>
                                    <input class="input w-100" type="tel" name="phone1" v-model="user.phone1" @input="input" maxlength="4" />
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col>
                                    <input class="input w-100" type="tel" name="phone2" v-model="user.phone2" @input="input" maxlength="4" />
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col>
                                    <input class="input w-100" type="tel" name="phone3" v-model="user.phone3" @input="input" maxlength="4" />
                                </v-col>
                            </v-row>
                            <!-- <div class="form-tel">
                                <input class="input" type="tel" name="phone1" v-model="user.phone1" @input="input" maxlength="4" />
                                <span class="text"></span>
                                <input class="input" type="tel" name="phone2" v-model="user.phone2" @input="input" maxlength="4" />
                                <span class="text"></span>
                                <input class="input" type="tel" name="phone3" v-model="user.phone3" @input="input" maxlength="4" />
                            </div> -->
                        </input-row>
                        <input-row label="이메일">
                            <v-row align="center" class="row--small">
                                <v-col>
                                    <input class="input w-100" type="text" name="email1" v-model="user.email1" />
                                </v-col>
                                <v-col cols="auto" class="pa-0">@</v-col>
                                <v-col>
                                    <input class="input w-100" type="text" name="email2" v-model="user.email2" />
                                </v-col>
                                <v-col>
                                    <select v-model="user.email3" class="select w-100" @change="user.email2 = user.email3">
                                        <option :value="null">직접입력</option>
                                        <option :value="`naver.com`">naver.com</option>
                                        <option :value="`daum.net`">daum.net</option>
                                        <option :value="`google.com`">google.com</option>
                                    </select>
                                </v-col>
                            </v-row>
                            <!-- <div class="form-email">
                                <input class="input" type="text" name="email1" v-model="user.email1" />
                                <span class="text">@</span>
                                <input class="input" type="text" name="email2" v-model="user.email2" />
                                <select v-model="user.email3" class="select" @change="user.email2 = user.email3">
                                    <option :value="null">직접입력</option>
                                    <option :value="`naver.com`">naver.com</option>
                                    <option :value="`daum.net`">daum.net</option>
                                    <option :value="`google.com`">google.com</option>
                                </select>
                            </div> -->
                        </input-row>
                        <input-row label="주소">
                            <v-row class="row--small">
                                <v-col sm="10">
                                    <input class="input w-100" type="text" v-model="user.postcode" placeholder="우편번호" readonly @click="onSearchPostcode" />
                                </v-col>
                                <v-col cols="auto" sm="2">
                                    <v-btn block elevation="0" dark color="grey-dark"
                                     @click="onSearchPostcode" class="w-100 h-100 input-btn"><span>검색</span></v-btn>
                                </v-col>
                                <v-col cols="12">
                                    <input class="input w-100" type="text" v-model="user.address1" placeholder="기본주소" readonly @click="onSearchPostcode" />
                                </v-col>
                                <v-col cols="12">
                                    <input class="input w-100" type="text" v-model="user.address2" placeholder="상세주소" />
                                </v-col>
                            </v-row>
                            <!-- <div class="form-address">
                                <div class="form-address__postcode">
                                    <input class="input" type="text" v-model="user.postcode" placeholder="우편번호" readonly @click="onSearchPostcode" />
                                    <button class="button button--primary" @click="onSearchPostcode">검색</button>
                                </div>
                                <input class="input" type="text" v-model="user.address1" placeholder="기본주소" readonly @click="onSearchPostcode" />
                                <input class="input" type="text" v-model="user.address2" placeholder="상세주소" />
                            </div> -->
                        </input-row>
                        <input-row label="관심분야">
                            <v-row>
                                <v-col v-for="parent in areas" :key="parent._id" cols="6" lg="">
                                    <v-row>
                                        <v-col>{{ parent.name }}</v-col>
                                    </v-row>
                                    <v-row v-for="child in parent.children" :key="child._id">
                                        <v-col>
                                            <v-checkbox :label="child.name" v-model="user._areas" :value="child._id" @input="input" hide-details dense class="my-0 py-0" />
                                        </v-col>
                                        <v-col cols="12" v-if="child.name == '기타(입력)' && user._areas.includes(child._id)" class="pt-0">
                                            <v-text-field v-model="user.areas_manual[parent._id]" hide-details dense class="my-0 py-0" outlined />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </input-row>
                    </div>
                </div>
            </div>
            <div class="join-row-wrap">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">회원정보 선택입력</h3>
                </div>
                <div role="table" class="board-table board-table--input">
                    <div role="rowgroup">
                        <input-row label="홈페이지 주소">
                            <input v-model="user.website" @input="input" name="website" class="w-100">
                        </input-row>
                        <input-row label="담당자정보">
                            <div class="row row--small">
                                <div class="col-12 col-md-6">
                                    <v-text-field v-model="user.workerName" @input="input" placeholder="이름" outlined hide-details dense />
                                </div>
                                <div class="col-12 col-md-6">
                                    <v-text-field v-model="user.workerTitle" @input="input" placeholder="직책" outlined hide-details dense />
                                </div>
                            </div>
                        </input-row>
                        <input-row label="주요생산제품">
                            <input v-model="user.mainProduct" @input="input" class="w-100">
                        </input-row>
                        <input-row label="기업개요">
                            <textarea v-model="user.summary" @input="input" />
                        </input-row>
                        <input-row label="기업로고">
                            <v-file-input v-model="user.avatar" @input="input" dense hide-details outlined accept="image/*" />
                        </input-row>
                        <form-files label="소개자료" v-model="user.brochures" @input="input" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 하단버튼 -->
        <div class="button-group">
            <v-btn @click="cancel()" large outlined rounded color="grey" elevation="0" class="min-w-120px min-w-lg-200px"><span class="color-grey">취소하기</span></v-btn>
            <v-btn @click="submit()" large rounded color="primary" elevation="0" class="min-w-120px min-w-lg-200px"><span>회원가입</span></v-btn>
        </div>
        <!-- <div class="bottom-button">
            <button class="button button--border-primary" @click="cancel()">
                <span>취소하기</span>
            </button>
            <button class="button button--primary" @click="submit()">
                <span>회원가입</span>
            </button>
        </div> -->

        <daum-postcode
            ref="daum-postcode"
            @change="
                ({ postcode, address }) => {
                    user.postcode = postcode;
                    user.address1 = address;
                }
            "
        ></daum-postcode>
    </div>
</template>

<script>
import { INDIVIDUAL_KINDS } from "@/assets/variables";

import InputRow from "@/components/client/dumb/input-row.vue";
import FormFiles from "../form-files.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";

const initialUser = {
    companyName: null,
    ceoName: null,
    establishedAt: null,
    businessNumber: null,
    website: null,
    workerName: null,
    workerTitle: null,
    mainProduct: null,
    summary: null,
    avatar: null,
    brochures: [],
};

export default {
    components: {
        InputRow,
        FormFiles,
        DaumPostcode,
    },
    props: ["value", "areas"],
    data() {
        return {
            user: { ...initialUser, ...this.$props.value } || { ...initialUser },

            INDIVIDUAL_KINDS,
        };
    },
    methods: {
        input() {
            this.$emit("input", this.user);
        },
        onSearchPostcode() {
            this.$refs["daum-postcode"].open();
        },
        cancel() {
            this.$router.go(-1);
        },

        submit() {
            if (this.validate()) this.$emit("submit", this.user);
        },

        validate() {
            try {
                if (!this.user.username) throw new Error("아이디를 입력해주세요.");

                if (!this.user.password) throw new Error("비밀번호를 입력해주세요.");
                if (!this.checkPassword(this.user.password)) return false;
                if (!this.user.passwordConfirm) throw new Error("비밀번호 확인을 입력해주세요.");
                if (this.user.password != this.user.passwordConfirm) throw new Error("비밀번호를 확인해주세요");

                if (!this.user.companyName) throw new Error("기업명을 입력해주세요.");
                if (!this.user.ceoName) throw new Error("대표자명을 입력해주세요.");
                if (!this.user.establishedAt) throw new Error("기업설립일을 입력해주세요.");
                if (!this.user.businessNumber) throw new Error("사업자등록번호를 입력해주세요.");

                if (!this.user.phone) throw new Error("휴대전화를 입력해주세요.");
                if (!this.user.email) throw new Error("이메일을 입력해주세요.");
                if (!this.user.postcode || !this.user.address1 || !this.user.address2) throw new Error("주소를 입력해주세요.");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");

            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");

            return true;
        },
    },
    watch: {
        "user.email"() {
            this.$emit("input", this.user);
        },
        "user.email1"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.email2"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },

        "user.phone"() {
            this.$emit("input", this.user);
        },
        "user.phone1"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone2"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone3"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
    },
};
</script>
